import { jsonMember, jsonObject } from 'typedjson';
import { Guid } from '@web/utils';

@jsonObject
export class WarehouseFileRequest {
  @jsonMember(String)
  public id!: Guid;

  public constructor(id: Guid) {
    this.id = id;
  }
}
